import { ChatMessage } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getChatConversationMessages(httpClient: HttpClient) {
  return (conversationId: string) =>
    httpClient.sendHttpRequest<ChatMessage[]>({
      endpoint: `/secured/conversations/${conversationId}/messages`,
      method: HttpMethods.GET,
    });
}

export { getChatConversationMessages };
